import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PrintService } from '../../services/print.service';
import { RegistrationModel } from 'src/app/registrations-data/models/data/registration.model';
import { ApartmentInfoModel } from 'src/app/registrations-data/models/data/apartment-info.model';

@Component({
  selector: 'app-apartment-info-template',
  templateUrl: './apartment-info-template.component.html',
  styleUrls: []
})
export class ApartmentInfoTemplateComponent implements OnInit {
  selectedApartment: ApartmentInfoModel;
  apartmentNumber: string;
  regForm: RegistrationModel;

  infoMapper = {
    address: 'The Apartment’s Street Address:'
  };

  constructor(private printService: PrintService,
              private route: ActivatedRoute) {
    this.apartmentNumber = route.snapshot.params.aptNumber;
  }

  ngOnInit() {
      try {
        this.regForm = this.printService.data;
        this.selectedApartment = this.regForm.apartments.find(x => x.apartmentDesignation === this.apartmentNumber);
      } catch (e) {
        alert('error');
      }
      this.printService.onDataReady();
  }
}
